function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d06716",
  fillRule: "nonzero",
  d: "M21.46 26.85c-1.29.24-2.88.06-3.89-.23-.85-.24-.83-.12-4.19-3.09-1.64-.12-4.12-1.15-5.61-2.94-1.51-1.83-2.35-4.24-2.35-6.83 0-5.18 3.17-10.18 9.28-10.18 4.81 0 8.76 3.97 8.76 9.76 0 4.91-2.67 8.47-5.85 9.56 1.69 1.32 2.18 2.06 4.08 3.15l-.23.8zm-5.51-5.35c.24.18.47.38.69.56 1.22-.56 2.78-3 2.78-7.82 0-5.85-2.11-9.41-5.26-9.41-2.88 0-4.68 3.65-4.68 8.26 0 4.59 1.56 8.3 4.31 9.18l2.16-.77z"
});

var SvgQueen = function SvgQueen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queen.210d0a50.svg";
export { ForwardRef as ReactComponent };